import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StadiumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stadium"}/>
}
